import { render, staticRenderFns } from "./Ludinavbar.vue?vue&type=template&id=d9e52afc&scoped=true&"
import script from "./Ludinavbar.vue?vue&type=script&lang=js&"
export * from "./Ludinavbar.vue?vue&type=script&lang=js&"
import style0 from "./Ludinavbar.vue?vue&type=style&index=0&id=d9e52afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e52afc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAppBar,VBtn,VDivider,VIcon,VImg,VList,VListItem,VListItemTitle,VMenu})
